import React from 'react';
import { SvgIcon, SvgIconProps } from "@mui/material";

export const PlusIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M18 10.5c.2708 0 .5.1042.6875.3125.2083.1875.3125.4167.3125.6875v1c0 .2708-.1042.5104-.3125.7188-.1875.1874-.4167.2812-.6875.2812h-4.5V18c0 .2708-.1042.5-.3125.6875C13 18.8958 12.7708 19 12.5 19h-1c-.2708 0-.5104-.1042-.7188-.3125C10.5938 18.5 10.5 18.2708 10.5 18v-4.5H6c-.2708 0-.5104-.0938-.7188-.2812C5.0938 13.0104 5 12.7708 5 12.5v-1c0-.2708.0938-.5.2813-.6875.2083-.2083.4479-.3125.7187-.3125h4.5V6c0-.2708.0938-.5.2812-.6875.2084-.2083.448-.3125.7188-.3125h1c.2708 0 .5.1042.6875.3125.2083.1875.3125.4167.3125.6875v4.5H18Z" />
    </SvgIcon>
);
